import Vue from 'vue'
import Router from 'vue-router'
import config from "../../config/index.js";
import common from "../units/common.js";


Vue.use(Router)

var options = {
  mode: 'history',//可选 'hash'/'history'/'abstract'
  routes: [
    { path: '/', name: 'Home', component: () => import('@/views/home/index.vue') },


    // { path: '/book/detail/podcopy/:id', component: () => import('@/views/book/detail/podcopy.vue') },
    // { path: '/podCast', component: () => import('@/views/details/podcast.vue') },





    { path: '/category', component: () => import('@/views/category/index.vue') },

    { path: '/Search', name: 'Search', component: () => import('@/views/book/search/index.vue') },
    { path: '/book/history', component: () => import('@/views/book/history/index.vue') },
    { path: '/book/search', component: () => import('@/views/book/search/index.vue') },
    { path: '/DzsDetail', component: () => import('@/views/book/detail/txt.vue') },
    { path: '/book/detail/txt/:id', component: () => import('@/views/book/detail/txt.vue') },
    { path: '/YssDetail', name: 'YssDetail', component: () => import('@/views/book/detail/pod.vue') },
    { path: '/book/detail/pod/:id', component: () => import('@/views/book/detail/pod.vue') },
    { path: '/book/poster/index/:id', component: () => import('@/views/book/poster/index.vue') },



    { path: '/ContentsAI', name: 'CatalogOutline', component: () => import('@/views/details/CatalogOutline.vue') },
    { path: '/AIChat', name: 'AIchat', component: () => import('@/views/details/AIchat.vue'), meta: { verify: true } },
    { path: '/MindMap', name: 'MindMap', component: () => import('@/views/details/MindMap.vue') },

    { path: '/MyCenter', name: 'MyCenter', component: () => import('@/views/center/MyCenter.vue'), meta: { verify: true } },
    { path: '/MyCollect', name: 'MyCollect', component: () => import('@/views/center/MyCollect.vue'), meta: { verify: true } },
    { path: '/MyHistory', name: 'MyHistory', component: () => import('@/views/center/MyHistory.vue'), meta: { verify: true } },
    { path: '/MyBorrowing', name: 'MyBorrowing', component: () => import('@/views/center/MyBorrowing.vue'), meta: { verify: true } },
    { path: '/MyShelf', name: 'MyShelf', component: () => import('@/views/center/MyShelf.vue'), meta: { verify: true } },
    { path: '/MyInfo', name: 'MyInfo', component: () => import('@/views/center/MyInfo.vue'), meta: { verify: true } },
    { path: '/MyReferrer', name: 'MyReferrer', component: () => import('@/views/center/MyReferrer.vue'), meta: { verify: true } },
    { path: '/AccountSet', name: 'AccountSet', component: () => import('@/views/center/AccountSet.vue'), meta: { verify: true } },
    { path: '/ModifyTel', name: 'ModifyTel', component: () => import('@/views/center/components/ModifyTel.vue'), meta: { verify: true } },
    { path: '/ModifyPassword', name: 'modifyPassword', component: () => import('@/views/center/components/ModifyPassword.vue'), meta: { verify: true } },
    { path: '/AiSessionHistory', name: 'AiSessionHistory', component: () => import('@/views/center/AiSessionHistory.vue'), meta: { verify: true } },
    { path: '/ChatHistory', name: 'ChatHistory', component: () => import('@/views/center/chathistory.vue'), meta: { verify: true } },
    { path: '/MyPurchase', name: 'MyPurchase', component: () => import('@/views/center/MyPurchase.vue'), meta: { verify: true } },
    { path: '/MyActivity', name: 'MyActivity', component: () => import('@/views/activity/center.vue'), meta: { verify: true } },
    { path: '/About', name: 'About', component: () => import('@/views/center/About.vue'), meta: { verify: true } },





    //{ path: '/Register', name: 'Register', component: Register },

    { path: '/Resource', name: 'Resource', component: () => import('@/views/resource/index.vue') },
    { path: '/Classics', name: 'Classics', component: () => import('@/views/classics/index.vue') },
    { path: '/Sheet', name: 'Sheet', component: () => import('@/views/sheet/index.vue') },

    { path: '/activity/index', component: () => import('@/views/activity/index.vue') },
    { path: '/activity/detail', component: () => import('@/views/activity/detail.vue') },
    { path: '/Rank', name: 'Rank', component: () => import('@/views/rank/index.vue') },
    // { path: '/ClassicsList', name: 'ClassicsList', component: () => import('@/views/classics/ClassicsList.vue') },


    { path: '/Work', name: 'Work', component: () => import('@/views/work/index.vue') },
    { path: '/WorkCenter', name: 'WorkCenter', component: () => import('@/views/work/center.vue') },
    { path: '/WorkModify', name: 'WorkModify', component: () => import('@/views/work/modify.vue'), meta: { verify: true, agency: false } },
    { path: '/WorkDetail', name: 'WorkDetail', component: () => import('@/views/work/detail.vue') },
    { path: '/work/player', component: () => import('@/views/work/player.vue') },
    { path: '/WorkSearch', name: 'WorkSearch', component: () => import('@/views/work/search.vue') },

    { path: '/MySheet', name: 'MySheet', component: () => import('@/views/sheet/center.vue') },
    { path: '/SheetDetail', name: 'SheetDetail', component: () => import('@/views/sheet/detail.vue') },
    { path: '/SheetModify', name: 'SheetModify', component: () => import('@/views/sheet/modify.vue') },


    { path: '/ActivityPoster', name: 'ActivityPoster', component: () => import('@/views/activity/poster.vue') },
    { path: '/Agreement', name: 'Agreement', component: () => import('@/views/agreement/index.vue') },
    // 绑定机构页面
    { path: '/selectAgency', name: 'selectAgency', component: () => import('@/views/center/selectAgency.vue'), meta: { agency: false } },
    //服务号绑定机构页面
    { path: '/bindOrg', name: 'bindOrg', component: () => import('@/views/external/BindOrg.vue'), meta: { agency: false } },
    { path: '/Register', name: 'Register', component: () => import('@/views/external/Register.vue'), meta: { agency: false } },

    { path: '/welcome', name: 'welcome', component: () => import('@/views/external/welcome/index.vue'), meta: { agency: false } },
    { path: '/welcomeCqu', name: 'welcomeCqu', component: () => import('@/views/external/welcome/cqu.vue'), meta: { agency: false } },
    { path: '/Agency', name: 'Agency', component: () => import('@/views/external/agency/index.vue'), meta: { agency: false } },

    { path: '/school/course/enroll/:id', name: 'SchoolCourseEnroll', component: () => import('@/views/school/course/enroll.vue'), meta: { verify: true, agency: false } },
    { path: '/school/course/center', name: 'SchoolCourseCenter', component: () => import('@/views/school/course/index.vue'), meta: { verify: true, agency: false } },
    { path: '/school/course/detail/:id', name: 'SchoolCourseDetail', component: () => import('@/views/school/course/detail.vue'), meta: { verify: true, agency: false } },
    { path: '/school/course/modify', name: 'SchoolCourseModify', component: () => import('@/views/school/course/modify.vue'), meta: { verify: true, agency: false } },
    // { path: '/school/course/audio-record', name: 'AudioRecord', component: () => import('@/views/school/course/AudioRecord.vue'), meta: { verify: true, agency: false } },

    { path: '/sso/login', name: 'login', component: () => import('@/views/school/sso/login.vue'), meta: { verify: true, agency: false } },
    { path: '/school/game/duration', name: 'SchoolGameDuration', component: () => import('@/views/school/game/duration.vue'), meta: { verify: true, agency: false } },
    { path: '/school/game/detail/:id', name: 'SchoolGameDetail', component: () => import('@/views/school/game/detail.vue') },
    { path: '/school/plan/detail/:id', component: () => import('@/views/school/plan/detail.vue') },
  ]
};
// 项目部署的子路径,无二级路径需注释
if (config.path.router) {
  options.base = config.path.router;
}

const router = new Router(options);

router.beforeEach((to, from, next) => {

  var agency = to.meta.agency == undefined ? true : to.meta.agency;
  // 获取登陆状态
  if (agency && common.member.agency.get()) {
    common.member.agency.remove();
    common.org.match();
  }
  // 移除微信信任登陆带过来的参数
  if (to.query.code) {
    var query = { ...to.query };
    delete query.code;
    delete query.state;

    next({ ...to, query: query }); // 移除参数后继续导航
  } else {
    next();
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js